import React from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import "./OrdersInLoadModal.scss";
import messages from '../../assets/i18n'
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ButtonStandard from "../ButtonStandard/ButtonStandard";
import SelectOrderOnModal from "../SelectOrderOnModal/SelectOrderOnModal";

function OrdersInLoadModal(props) {
	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const ordersModal = useSelector(state => state.ordersModal);

	const handleChecked = () => {

		dispatch({
			type: "ADD_ORDER_LOAD",
			loadId: props.load,
			orderlist: ordersModal.selectOrdersModal
		});

		props.onHide();

	}

	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			className="load-modal"
			centered
		>
			<Modal.Header className="text-center" closeButton>
				<Modal.Title className="w-100">{messages[lang].orders}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{ordersModal.ordersModal === null ?
					<Container>
						<Row className="justify-content-center mt-5">
							<LoadingSpinner />
						</Row>
					</Container>
					:
					ordersModal.ordersModal.length <= 0 ?
						<Container>
							<Row className="justify-content-center mt-5">
								<h3>{messages[lang].notExistOrderToBeInclude}</h3>
							</Row>
						</Container>
						:
						<Container className="load-details-page">
							<div className="div-background"></div>
							<Row className="table-header">
								<Col className="d-flex">
									<Col className="bg-color-tertiary col-0-5 py-2 border-right" />

									<Col className="bg-color-tertiary py-2 border-left border-right">
										<span className="text-2">{messages[lang].orderNumber}</span>
									</Col>

									<Col className="bg-color-tertiary py-2 border-left border-right">
										<span className="text-2">{messages[lang].numberParts}</span>
									</Col>

									<Col className="bg-color-tertiary py-2 border-left border-right">
										<span className="text-2">{messages[lang].numberVolumes}</span>
									</Col>

									<Col className="bg-color-tertiary py-2 border-left border-right">
										<span className="text-2">{messages[lang].dateIssue}</span>
									</Col>

									<Col className="bg-color-tertiary py-2 border-left border-right">
										<span className="text-2">{messages[lang].nature}</span>
									</Col>

									<Col className="bg-color-tertiary py-2 border-left">
										<span className="text-2">{messages[lang].status}</span>
									</Col>
								</Col>
							</Row>

							{
								ordersModal.ordersModal.map((order) => {
									return (
										<SelectOrderOnModal order={order} key={order.id} />
									)
								})
							}

						</Container>
				}
			</Modal.Body>
			<Modal.Footer>
				<ButtonStandard
					id="load_modal_add_order_button"
					text={messages[lang].includeOrders}
					textClass="text-3"
					disabled={ordersModal.selectOrdersModal.length <= 0}
					className="btn btn-primary btn-standard px-3 py-2 btn-primary btn-rounded"
					onClick={() => handleChecked()}
				/>
			</Modal.Footer>
		</Modal>
	);
}

export default OrdersInLoadModal;
